<template>
    <div v-if="isShow" :class="{ 'rsv2_user_pop_wrap': isUserInfo == true, 'pop_overlay_black': isReservation == true }"
        style="z-index: 506;">
        <div class="pop_wrap" :class="{ 'rsv2_user_pop': isUserInfo == true, 'rsv2_rsv_pop': isReservation == true }"
            style="min-height: 870px">
            <div v-if="isHServiceLoading || isLoading" class="loading_bg" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                r="30" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="pop_title">
                <div class="title">{{ titleString }}</div>
                <button class="mgl_auto" @click="action_ClosePopup">
                    <v-icon large>mdi-close</v-icon>
                </button>
            </div>
            <div class="pop_cont rsv2_info_pop">
                <Left ref="Left" :isShowPopup="isShow" :hservice="hservice" :isShowUserInfoTitle="isReservation" />
                <Right v-if="isReservation" />
            </div>
        </div>
    </div>
</template>


<script>
import { mapState } from 'vuex'

import { closeAlertPopup } from '../../../sheet-alert'
import { sheetState } from '../../../sheet-state'
import { closePopup, sheetOverlays } from '../../../sheet-overlays'
import { clearSaaSTimeSelectMode, reservationSelection } from '../../../reservation-selection'
import { editGuardState, invokeGuard, setEditBasicInfo, setUserNoteChangedStatus } from './popup-edit-guard'
import Left from './Left/Left.vue'
import Right from './Right/Right.vue'
import { useQueryClient } from '@tanstack/vue-query'
import { hserviceFindQueryOptions } from '@/composables/queries/hservice/use-hservice-find-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'

export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    components: {
        Left, Right
    },
    data() {
        return {
            isHServiceLoading: false,
            sheetState,
            sheetOverlays,
            reservationSelection,
            editGuard: editGuardState,
            hservice: undefined,
        }
    },
    mounted() {
        this.registEventListner()
    },
    destroyed() {
        this.unregistEventListner()
    },
    watch: {
        isShow: {
            handler: function (newValue) {
                if (newValue) { return }
                setEditBasicInfo(false)
                setUserNoteChangedStatus(false)
            }
        },
        'reservationSelection.selectedHService': {
            immediate: true,
            deep: true,
            handler: function (newValue) {
                this.hservice = undefined
                if (newValue?._id == undefined) {
                    this.hservice = newValue
                } else {
                    this.loadHService(newValue._id)
                }
            }
        },
        'remote_notification.d_HServiceUpdate_el': {
            immediate: true,
            deep: true,
            handler: function (newValue) {
                if (this.hservice?._id == undefined) { return }
                if (newValue?.data?.hserviceID == this.hservice?._id) {
                    this.loadHService(this.hservice?._id)
                }
            }
        }
    },
    computed: {
        ...mapState(['remote_notification']),
        isShow: function () {
            if (this.isUserInfo == true || this.isReservation == true) { return true }
            return false
        },
        isUserInfo: function () {
            return this.sheetOverlays.isShowUserInfoPopup
        },
        isReservation: function () {
            return this.sheetOverlays.isShowReservationPopup
        },
        titleString: function () {
            return this.isUserInfo == true ? this.$t('popup_user_reservation.title') : this.$t('popup_user_reservation.title_appointment')
        },
        isLoading: function () {
            return this.sheetState.isPopupLoading
        }
    },
    methods: {
        // MARK: - Network
        async loadHService(hserviceID) {
            this.isHServiceLoading = true
            try {
                let hospitalID = this.hospital.selectedHospital._id
                let model = {
                    _id: hserviceID,
                    hospitalID: hospitalID
                }
                let services
                try {
                    services = await this.queryClient.fetchQuery(hserviceFindQueryOptions(model))
                } catch (err) {
                    // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                    if (!isApiErrorWithCode(err)) throw err
                    console.log(err)
                    return
                }
                if (services.length == 0) {
                    console.log(services)
                    return
                }
                this.hservice = services[0]
            } finally {
                this.isHServiceLoading = false
            }
        },

        // MARK: - Actions
        action_KeyDownESC() {
            this.action_ClosePopup()
        },
        async action_ClosePopup() {
            if (this.editGuard.isEditBasicInfo) {
                let result = await invokeGuard('AlertEditUserBasicInfo')
                if (result == false) {
                    closeAlertPopup()
                    return
                }
            } else if (this.editGuard.isUserNoteChanged) {
                await invokeGuard('AlertEditUserNote')
            }

            closePopup()
            clearSaaSTimeSelectMode()
        },

        // MARK: - Regist Key Event Listener
        handleKeydown(event) {
            if (event.keyCode === 27) {
                this.action_KeyDownESC()
            }
        },
        registEventListner() {
            window.addEventListener('keydown', this.handleKeydown)
        },
        unregistEventListner() {
            window.removeEventListener('keydown', this.handleKeydown)
        }
    }
}
</script>


<style scoped></style>